import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"],
  _excluded2 = ["children"],
  _excluded3 = ["children", "size", "priority"];
import { CoreDomainSearchBaseLayout } from '@wix/core-domain-search';
import { Box, Button } from '@wix/design-system';
import clsx from 'clsx';
import React, { useCallback, useMemo } from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './resultsSearchBarV4.scss';
export const V4_CONTENT_MAX_WIDTH = '980px';
export const V4_SEARCH_BAR_PLACEHOLDER_KEY = 'domains_search_gate.new_searchbar.placeholder';
const SearchContainer = _ref => {
  let children = _ref.children,
    className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: "vertical",
    backgroundColor: "#FFFFFF",
    width: "100%",
    maxWidth: V4_CONTENT_MAX_WIDTH,
    zIndex: 1
  }, props, {
    className: clsx(s.searchContainer, className)
  }), children);
};
const StatusContainer = props => /*#__PURE__*/React.createElement(CoreDomainSearchBaseLayout.StatusContainer, _extends({}, props, {
  maxWidth: V4_CONTENT_MAX_WIDTH
}));
const InputContainer = _ref2 => {
  let children = _ref2.children,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: "horizontal",
    verticalAlign: "middle",
    align: "space-between",
    width: "100%",
    padding: "7px 12px",
    flex: 1,
    gap: "SP1"
  }, props), children);
};
const ToolBarContainer = () => /*#__PURE__*/React.createElement(React.Fragment, null);
export const useResultsSearchBarV4Layouts = () => {
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const ActionButton = useCallback(_ref3 => {
    let _icon = _ref3.children,
      _size = _ref3.size,
      _priority = _ref3.priority,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
    return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
      size: "medium",
      skin: "dark",
      priority: "secondary",
      className: clsx(s.actionButton, props.className)
    }), t('domains_search_gate.gate_revamp.searchbar.submit.cta'));
  }, [t]);
  return useMemo(() => ({
    SearchContainer,
    StatusContainer,
    InputContainer,
    ActionButton,
    ToolBarContainer
  }), [ActionButton]);
};
//# sourceMappingURL=resultsSearchBarV4Layouts.js.map